/**
 * Return the category -> fill map from the ECharts option that is actually on screen.
 * The option is authoritative here: horizontal bars reverse their prepared rows, and
 * schema coloring is applied only while building the option. Reading the aligned axis
 * and series data keeps 3D isolation colors identical to the rendered chart.
 */
export function extractRenderedCategoryColors(option) {
  const series = option && Array.isArray(option.series) ? option.series[0] : null;
  const data = series && Array.isArray(series.data) ? series.data : [];
  if (!series || !data.length) return {};

  const result = {};
  if (series.type === 'pie') {
    data.forEach((datum) => {
      const label = datum && datum.name != null ? String(datum.name).trim() : '';
      const color = datum && datum.itemStyle && datum.itemStyle.color;
      if (label && typeof color === 'string' && color) result[label] = color;
    });
    return result;
  }

  const yAxis = option && !Array.isArray(option.yAxis) ? option.yAxis : null;
  const xAxis = option && !Array.isArray(option.xAxis) ? option.xAxis : null;
  const labels = yAxis && yAxis.type === 'category' && Array.isArray(yAxis.data)
    ? yAxis.data
    : (xAxis && xAxis.type === 'category' && Array.isArray(xAxis.data) ? xAxis.data : []);

  labels.forEach((rawLabel, index) => {
    const label = rawLabel != null ? String(rawLabel).trim() : '';
    const datum = data[index];
    const color = datum && typeof datum === 'object' && datum.itemStyle
      ? datum.itemStyle.color
      : null;
    if (label && typeof color === 'string' && color) result[label] = color;
  });
  return result;
}
